<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('finance.moneyTransfersTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_money_transfer: 'add_money_transfer'
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addMoneyTransferButton="true"
          :openAddMoneyTransferModal="openAddMoneyTransferModal"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.money_transfer_id"
              >
                <!-- <td>{{ r.branch_name }}</td> -->
                <td>{{ r.from_bank }}</td>
                <td>{{ r.to_bank }}</td>
                <td>{{ r.amount | currency }}</td>
                <td>{{ r.expense_amount | currency }}</td>
                <td>
                  <v-chip
                    small
                    label
                    :color="r.status == 'pending' ? 'orange' : 'green'"
                    outline
                  >
                    {{ r.status }}
                  </v-chip>
                </td>
                <td>{{ r.note }}</td>
                <td>{{ r.full_name }}</td>
                <td>{{ r.created_at }}</td>
                <td>
                  <div class="d-flex">
                    <a
                      v-if="r.status == 'pending' && $_has_perm('approve_money_transfer')"
                      class="px-2"
                      :tooltip="$t('orders.approveTooltip')"
                      style="color: #43a047"
                      @click="approveMoneyTransfer(r.money_transfer_id)"
                    >
                      <i class="material-icons">check_circle</i>
                    </a>
                    <a
                      v-if="r.status == 'pending' && $_has_perm('delete_money_transfer')"
                      class="px-2"
                      :tooltip="$t('common.delete')"
                      @click="deleteMoneyTransfer(r.money_transfer_id)"
                    >
                      <v-icon color="red darken-2">delete</v-icon>
                    </a>
                  </div>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <add
            :addMoneyTransferModal="addMoneyTransferModal"
            :formData="formData"
            :isUpdate="false"
            :banksList="banksList"
            @close="addMoneyTransferModal = false"
            @resetTable="resetGetResults()"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import add from './add'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    add,
  },
  mounted() {
    this.perPageFix()
    this.getBanksList()
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    let sortOrders = {}
    let columns = [
      // {
      //   label: 'Branch',
      //   text: 'Branch',
      //   value: '1',
      //   sortable: true,
      //   searchable: false,
      //   name: 'branch_name',
      // },
      {
        label: this.$t('columns.fromBank'),
        text: this.$t('columns.fromBank'),
        value: '1',
        sortable: true,
        searchable: true,
        name: 'from_bank',
      },
      {
        label: this.$t('columns.toBank'),
        text: this.$t('columns.toBank'),
        value: '2',
        sortable: true,
        searchable: true,
        name: 'to_bank',
      },
      {
        label: this.$t('columns.amount'),
        text: this.$t('columns.amount'),
        value: '3',
        sortable: true,
        searchable: true,
        name: 'amount',
      },
      {
        label: this.$t('columns.expenseAmount'),
        text: this.$t('columns.expenseAmount'),
        value: '4',
        sortable: true,
        searchable: true,
        name: 'expense_amount',
      },
      {
        label: this.$t('columns.status'),
        text: this.$t('columns.status'),
        value: '5',
        sortable: true,
        searchable: true,
        name: 'status',
      },
      {
        label: this.$t('columns.note'),
        text: this.$t('columns.note'),
        value: '6',
        sortable: true,
        searchable: true,
        name: 'note',
      },
      {
        label: this.$t('columns.staff'),
        text: this.$t('columns.staff'),
        value: '7',
        sortable: true,
        searchable: true,
        name: 'full_name',
      },
      {
        label: this.$t('common.date'),
        text: this.$t('common.date'),
        value: '8',
        sortable: true,
        searchable: true,
        name: 'created_at',
      },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/money_transfers',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addMoneyTransferModal: false,
      theMoneyTransferID: '',
      prevSearchQuery: '',
      money_transferTypesList: [],
      suppliersList: [],
      banksList: [],
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'money_transfer_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getBanksList() {
      var token = localStorage.getItem('access_token')
      axios.get('api/get_banks', { headers: { Authorization: 'Bearer ' + token } }).then((res) => {
        this.banksList = []
        res.data.data.forEach((e) => {
          this.banksList.push({ text: e.bank_name, value: e.bank_id })
        })
      })
    },

    openAddMoneyTransferModal() {
      this.formData = {}
      this.isUpdate = false
      this.addMoneyTransferModal = true
    },

    openEditMoneyTransferModal(data) {
      this.formData = data
      this.isUpdate = true
      this.addMoneyTransferModal = true
    },

    approveMoneyTransfer(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true,
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .get(`api/money_transfers/approve/${id}`, { headers: { Authorization: 'Bearer ' + token } })
            .then((response) => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1000,
                buttons: false,
              })
            })
            .catch(() => { })
        }
      })
    },

    deleteMoneyTransfer(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true,
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(`api/money_transfers/${id}`, { headers: { Authorization: 'Bearer ' + token } })
            .then((response) => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false,
              })
            })
            .catch(() => { })
        }
      })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true,
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },
  },
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/moneyTransfer/moneyTransfer.vue